<style lang="scss" scoped>
 .banner-container {
   height: 384px;
   position: relative;
   .feedback-btn {
     position: absolute;
     bottom: 0;
     right: 24px;
     font-size: 24px;
     color: #999999;
     display: flex;
     align-items: center;
     .question-icon {
       height: 18px;
       width: 18px;
       margin-left: 6px;
     }
   }
   .banner {
     height: 384px;
     .banner-img {
       height: 384px;
       width: 100%;
       box-sizing: border-box;
       display: block;
      //  padding: 20px;
       object-fit: contain;
       background-color: #ffffff;
     }
   }

   .feedback-container {
      display: flex;
      flex-wrap: wrap;
      // justify-content: space-between;
      padding: 0 24px;
      .feedback-item {
        height: 88px;
        margin-bottom: 24px;
        margin-right: 22px;
        color: #1d1d1d;
        font-size: 28px;
        padding: 0 32px;
        line-height: 88px;
        background-color: #eeeeee;
        border-radius: 2px;
      }
   }

 }

</style>
<template>
  <div class="banner-container">
    <van-swipe class="banner" @change="bannerChange">
      <van-swipe-item v-for="(image, index) in bannerList" :key='index' @touchstart="startTouch($event)"  @touchend="previewImage($event)">
        <img class="banner-img" v-lazy="image">
      </van-swipe-item>
    </van-swipe>
    <!-- <div v-if="type==0" class="feedback-btn" @click="feedbackToggle" >
      问题反馈
      <img class="question-icon" src="./../../../assets/images/ai-picture/question.png">
    </div> -->
    <van-action-sheet v-model="showFeedback" :round="false" :safe-area-inset-bottom="true" title="问题反馈"  cancel-text="取消">
      <div class="feedback-container">
        <div v-for="(item, index) in feedbackList" class="feedback-item" :key="index" @click="feedback(item)">{{item}}</div>
      </div>
      <!-- <div class="feedback-container">有问题快讲</div> -->
    </van-action-sheet>
  </div>
</template>
<script>
import { ImagePreview, Swipe, SwipeItem, ActionSheet, Toast } from 'vant';
import { feedBackProduct } from './../../../common/api/ai-picture';

export default {
  components: {
    ImagePreview, 
    'van-swipe': Swipe, 
    'van-swipe-item': SwipeItem,
    'van-action-sheet': ActionSheet,
  },
  props: {
    bannerList: {
      default: () => {
        return []
      }
    },
    logId: {
      default: ''
    },
    type: {
      default: ''
    }
  },
  data () {
    return {
      startIndex: 0,
      showFeedback: false,
      feedbackList: ['识别错误', '价格错误', '名称错误', '推荐不感兴趣'],
      preTime: 0,
      pageX: 0,
      pageY: 0,
    }
  },
  methods: {
    bannerChange (index) {
      this.startIndex = index;
    },
    startTouch (e) {
      console.log(e);
      const touch = e.changedTouches[0];
      this.preTime = new Date();
      this.pageX = touch.pageX;
      this.pageY = touch.pageY;
    },
    previewImage (e) {
      const touch = e.changedTouches[0];
      const curTime = new Date();
      console.log(curTime - this.preTime, Math.abs(touch.pageX - this.pageX));
      if ((curTime - this.preTime > 80) || Math.abs(touch.pageX - this.pageX) > 10) {
        return
      }
      ImagePreview({
        images: this.bannerList,
        startPosition: this.startIndex,
        closeable: true
      })
    },
    feedbackToggle (e) {
      e.stopPropagation()
      this.showFeedback = true;
    },
    feedback (msg) {
      feedBackProduct({ logId: this.logId, feedback: msg })
        .then(result => {
          console.log(result);
          if (result && result.errorCode === 0) {
            this.showFeedback = false;
            Toast('反馈成功');
          }
        })
    }
  },
  mounted () {}

}
</script>
